import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('subscription', {
      storePlans: (state) => state.plans,
    }),
    ...mapState('company', {
      activeCompany: (state) => state.activeCompany,
    }),
  },
  methods: {
    getActiveSubscription() {
      const activeSub = this.activeCompany.activeSubscription;
      let nextBillingDate;
      if (activeSub.priceId == 'free') {
        return {
          name: 'Free',
          description: 'Free plan',
          price: 0,
          frequency: 'per month',
        };
      } else {
        let storePlan = this.storePlans.find(
          (plan) => plan.id == activeSub.planId
        );
        let price = storePlan.plan_prices.find(
          (price) => price.stripeId == activeSub.priceId
        );

        if (price.frequency == 'MONTHLY') {
          const currentStartDate = new Date(activeSub.currentStartDate);

          // Extract year, month, and day components
          const year = currentStartDate.getFullYear();
          const month = currentStartDate.getMonth() + 1; // Note: month is zero-based
          const day = currentStartDate.getDate();

          // Increment the month by 1, adjusting the year if necessary
          let nextYear = year;
          let nextMonth = month + 1;
          if (nextMonth > 12) {
            nextYear++;
            nextMonth = 1;
          }
          // Create the next billing date
          nextBillingDate = new Date(
            nextYear,
            nextMonth - 1,
            day
          ).toDateString();
        } else {
          const currentStartDate = new Date(activeSub.currentStartDate);

          const year = currentStartDate.getFullYear();
          const month = currentStartDate.getMonth() + 1; // Note: month is zero-based
          const day = currentStartDate.getDate();

          const nextYear = year + 1;

          // Create the next billing date
          nextBillingDate = new Date(nextYear, month - 1, day).toDateString();
        }

        return {
          name: storePlan.name,
          description:
            storePlan.name == 'Premium'
              ? 'From Operational to Scaling'
              : 'From Validation to Commercialization',
          price: price.price,
          frequency: price.frequency,
          nextBillingDate: nextBillingDate,
        };
      }
    },
  },
};
